/* eslint-disable max-lines-per-function */
import { useState, useEffect } from "react";
import { cn } from "tailwind-variants";
import Spinner from "components/jiffy/react-cart/Spinner.vue";
import ColorPicker from "../ColorPicker.vue";
import { useDtfStore } from "../store";
import "./Preview.scss";

export default function Preview(props = {}) {
  const { className, ...otherProps } = props;
  const colors = [
    "#000000",
    "#FFFFF0",
    "#4169E1",
    "#DC143C",
    "#228B22",
    "#671EA1",
    "#708090",
    "#FFD700",
    "#CC5500",
    "#191970",
    "#800020"
  ];
  const defaultStyle = "straight";
  const [touched, setTouched] = useState(false);
  const store = useDtfStore();
  const [selection, setSelection] = useState(colors[1]);
  const [previewClass, setPreviewClass] = useState(
    `preview__box--${store.letterNumberArtwork.style || defaultStyle}`
  );

  function letterNumberArtwork() {
    return store.letterNumberArtwork;
  }

  function currentColor() {
    return letterNumberArtwork().color || "#000000";
  }

  function imagePreview() {
    const { style, url } = letterNumberArtwork();
    if (style) {
      return url;
    }
    return `https://jiffy.imgix.net/gen/letters-pdp/${defaultStyle}-2.png`;
  }

  function letterPreviewLoading() {
    return store.letterPreviewLoading;
  }

  function dtfMaxHeight() {
    return store.dtfMaxHeight;
  }

  function imageScale() {
    const { sizes, style } = letterNumberArtwork();
    // If the current textbox index dimensions is not yet ready. Default to dimensions with
    // undefined key (default dimensions).
    // This avoids jumpiness on the UI.
    const activeSize = sizes[letterNumberArtwork().textIndex] || sizes[undefined];
    if (style === "vertical" || !activeSize) return "scale(1)";
    let scaleValue = activeSize.height / dtfMaxHeight();
    if (scaleValue > 1) scaleValue = 1;
    return `scale(1, ${scaleValue})`;
  }

  useEffect(() => {
    if (!touched) {
      setSelection(currentColor() === "#FFFFFF" ? "#000000" : "#FFFFF0");
    }
  }, [touched]);

  function handleSelect(color) {
    setTouched(true);
    setSelection(color);
  }

  function handleImageLoad() {
    store.setLetterPreviewLoading(false);
    setPreviewClass(`preview__box--${letterNumberArtwork().style || defaultStyle}`);
  }

  return (
    <div
      {...otherProps}
      className={cn("preview", className)}
      style={{
        "--1975d184-imageScale": imageScale()
      }}
    >
      <div
        className={cn("preview__box", previewClass)}
        style={{
          backgroundColor: selection
        }}
      >
        {imagePreview() ? (
          <img
            className="preview__image"
            src={imagePreview()}
            alt="preview"
            onLoad={handleImageLoad}
          />
        ) : null}
        {letterPreviewLoading() ? (
          <Spinner className="preview__spinner" data-testid="preview-spinner" />
        ) : null}
      </div>
      <p className="preview__label">Change Background Color</p>
      <ColorPicker
        value={selection}
        colors={colors}
        onChange={handleSelect}
        data-testid="color-picker"
      />
      <p className="preview__preview-notice">Preview Only: Background Color Won't Be Printed</p>
    </div>
  );
}
